import PropTypes from 'prop-types';
import { Text, View } from '@react-pdf/renderer';

import { COLORS, styles } from './styles';

const getScoreColor = score => {
  const num = Number(score);

  if (num > 40) {
    return COLORS.scoreGreen;
  }
  if (num >= 0) {
    return COLORS.scoreYellow;
  }

  return COLORS.scoreRed;
};

const formatDateToWords = date => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const d = new Date(date);

  return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
};

const PdfScoreSection = ({ score, title, findingsCount, template, generatedAt }) => {
  const size = 48;
  const scoreColor = getScoreColor(score);
  const templateDisplay = template === 'UX Critique' ? 'Usability Audit' : template;

  return (
    <View style={styles.scoreRow}>
      {score != null && (
        <View
          style={{
            width: size,
            height: size,
            borderRadius: size / 2,
            borderWidth: 3,
            borderColor: scoreColor,
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: COLORS.white,
            marginRight: 10,
          }}
        >
          <Text style={{ fontSize: 20, fontWeight: 600, color: COLORS.textPrimary, lineHeight: 1 }}>
            {score}
          </Text>
          <Text style={{ fontSize: 8, fontWeight: 400, color: COLORS.textGrey, lineHeight: 1 }}>
            NPS
          </Text>
        </View>
      )}
      <View style={styles.scoreMeta}>
        <Text style={styles.scoreTitle}>
          {title}
        </Text>
        <Text style={styles.scoreSubtitle}>
          {findingsCount}
          {' finding'}
          {findingsCount === 1 ? '' : 's'}
          {templateDisplay ? ` | ${templateDisplay}` : ''}
          {generatedAt ? ` | ${formatDateToWords(generatedAt)}` : ''}
        </Text>
      </View>
    </View>
  );
};

PdfScoreSection.propTypes = {
  score: PropTypes.number,
  title: PropTypes.string.isRequired,
  findingsCount: PropTypes.number.isRequired,
  template: PropTypes.string,
  generatedAt: PropTypes.string,
};

export default PdfScoreSection;
